import { getReq } from './axios';
import { allReferenceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/pending-commission-amounts");
export var getPendingCommissionAmounts = function getPendingCommissionAmounts(params) {
  return getReq(BASE_URL, {
    params: allReferenceParams(params)
  });
};